export const METHODS = [
// @ts-ignore checking for prototype
Object.prototype.toJSON,
// @ts-ignore checking for prototype
Array.prototype.toJSON,
// @ts-ignore checking for prototype
String.prototype.toJSON];